
export default [
  {
    name: "Mountain ranges",
    value: "mountain-ranges",
    url: "/backgrounds/mountain-ranges.jpg",
    description : `By <a href="https://unsplash.com/@asoggetti/portfolio" target="_blank">Asoggetti</a>`,
  },
  {
    name: "Dusk",
    value: "dusk",
    url: "/backgrounds/dusk.jpg",
    description : `By <a href="https://www.instagram.com/mohamad.a.z/?utm_medium=referral&utm_source=underlineme" target="_blank">Mohammad Alizade</a>`,
  },
  {
    name: 'Mountains',
    value: "mountains",
    url: "/backgrounds/mountains.jpg",
    description : `By <a href="https://levelofambiguity.tumblr.com/?utm_medium=referral&utm_source=underlineme" target="_blank">Marcelo Quinan</a>`,
  },
  {
    name: 'Highway',
    value: "highway",
    url: "/backgrounds/highway.jpg",
    description : `By <a href="https://www.instagram.com/thisisflik/?utm_medium=referral&utm_source=underlineme" target="_blank">Steven Pahel</a>`,
  },
  {
    name: 'Dawn',
    value: "dawn",
    url: "/backgrounds/dawn.jpg",
    description : `By <a href="https://www.pictorem.com/profile/Marek.Piwnicki" target="_blank">Marek Piwnicki</a>`,
  },
  {
    name: 'Grampians 1',
    value: "grampians1",
    url: "/backgrounds/grampians1.jpg",
    description : `By <a href="https://www.instagram.com/manan057/" target="_blank">Manan Rana</a>`,
  },
  {
    name: 'Grampians 2',
    value: "grampians2",
    url: "/backgrounds/grampians2.jpg",
    description : `By Shashwat Amin`,
  },
  {
    name: 'Canyon',
    value: "canyon1",
    url: "/backgrounds/canyon1.jpg",
    description : `By <a href="https://www.eleonorapatricola.com/?utm_medium=referral&utm_source=underlineme" target="_blank">Eleonora Patricola</a>`,
  },
  {
    name: 'Abstract 1',
    value: "abstract1",
    url: "/backgrounds/abstract1.jpg",
    description : `By <a href="https://adrienconverse.com/?utm_medium=referral&utm_source=underlineme" target="_blank">Adrien Converse</a>`,
  },
  {
    name: 'Abstract 2',
    value: "Abstract 2",
    url: "/backgrounds/abstract2.jpg",
    description : `By <a href="https://www.instagram.com/eberhard_grossgasteiger/?utm_medium=referral&utm_source=underlineme" target="_blank">Eberhard Grossgasteiger</a>`,
  },
  {
    name: 'Abstract 3',
    value: "abstract3",
    url: "/backgrounds/abstract3.jpg",
    description : `By <a href="https://unsplash.com/@qrenep" target="_blank">Rene Böhmer</a>`,
  },
  {
    name: "No background",
    value: "none",
    description : "No background"
  },
];